module.exports = __webpack_public_path__ + "static/media/fa-brands-400.592643a8.eot";